export default {"src":"/_next/static/media/rebranded-gray-icon.53b97d38.svg","height":31,"width":30,"blurWidth":0,"blurHeight":0};